export default "__VITE_PUBLIC_ASSET__569e2d95__"